module.exports = __webpack_public_path__ + "img/pic_my_bg_nor@2x.8a841c33.png";